<template>
  <el-col class="mb10" :xs="24" :sm="w100 ? 24 : 12" :md="w100 ? 24 : w50 ? 12 : 8">
    <div class="w100 flex-box al-c">
      <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
      <div class="flex-1">
        <el-select class="w100" v-model="value" value-key="value" @change="changeValue" :placeholder="typeData.placeholder ? typeData.placeholder : '请选择'">
          <el-option v-for="(val, key) in typeData.data" :key="key" :label="val.label" :value="val"></el-option>
        </el-select>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "CascaderSelectComp",
  props: ["type-data", "step-key", "w100", "w50", "width"],
  components: {},
  data() {
    return {
      value: null
    };
  },
  created() {
    if (this.typeData.value || this.typeData.value == "") {
      for (const item of this.typeData.data) {
        if (item.value == this.typeData.value) {
          this.value = item;
          this.changeValue(item);
          break;
        }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    changeValue(value) {
      // console.log(value);
      this.$emit(
        "change-child",
        value.value,
        this.stepKey,
        value.hasChild ? true : false
      );
    }
  },
  watch: {
    // 'typeData.data': {
    //     handler(value) {
    //         this.value = null;
    //     },
    //     deep: true
    // }
  }
};
</script>
